import { graphql } from "relay-runtime"

export const chPhysiotherapyFragment = graphql`
  fragment chPhysiotherapyFragment on ch_PhysiotherapyPrescription {
    id
    patientId
    aims
    allergies
    conditions
    medicationIds
    conditionStage
    createdAt
    createdBy
    diagnosisCode
    duration
    fileId
    healthcareProviderId
    internalNote
    language
    leadingSymptom
    prescriptionRepetition
    progressNoteId
    reason
    sides
    signedAt
    signedBy
    treatmentUnit
    trigger
    treatmentUnitPerDay
    isHomeTreatment
    occurrence
    updatedAt
    updatedBy
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
